import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';
import {useUserStore} from "../../../hooks/admin/user";
import {useAxiosIndicatorCheck} from 'src/store/hook/useAxiosIndicatorCheck';
import {AgGridReact} from 'ag-grid-react';
import store from 'src/storeWire';
import {system_notification} from 'src/store/slice/system';
import useReduxState from 'src/hooks/useReduxState';
import NoResultContent from '../../HomePageContent/NoResultContent';
import {__remove, __set} from 'src/store/axios_indicator';
import System from 'src/helper/system';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';
import Admin from '@system/config/admin';
import RoleSelection from '../AdminModals/RoleSelection';
import {useAdminCommonStore} from 'src/hooks/admin/adminCommon';
import {Tooltip} from 'src/component/Tooltip';


var roleData = [];
var isEditGlobal = false;

export function UserSponsorAcctList(props) {
  const [__check] = useAxiosIndicatorCheck();
  const [{
    userDetail,
    userAcctList,
    totalUserRecords,
    userAcctListMessage,
    selectedRoles
  }, {get_user_acct_list}, {
    set_role_selection_popup_status,
    set_select_user_sponsor_accounts,
    update_user_roles
  }] = useUserStore();
  const [selectionCount, setSelectionCount] = useState(0);
  const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
  const [isEdit] = useReduxState(false, 'setIsEdit');
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const userId = props.userId;
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const [{roleList}] = useAdminCommonStore();
  const [selectedIndex, setIndex] = useState(-1);
  const [isSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');

  const addRole = (e) => {
    let data;
    if (e.data) {
      data = e.data;
    } else if (e.node.field === 'Role') {
      data = e.node.allLeafChildren[0]?.data;
    } else return "";
    const role = data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = data.Source === "SAP" || isEditGlobal ? <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select Role (required)'}</span> :
      <a className={'text-blue2'} onClick={() => {
        openPopup(e.data, e.rowIndex)
      }}><u>
          {role.length > 0 ? renderedRole : 'Select Role (required)'}
        </u>
      </a>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }
  const roleSortingAgGrid = (roleA, roleB) => {
    let renderedRoleA = Helper.renderRoles(roleA, roleData);
    let renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }
  const openPopup = (account, rowIndex) => {
    setIndex(rowIndex)
    set_select_user_sponsor_accounts({account, userData: {userName: account.UserName}})
    set_role_selection_popup_status(true);
  };

  useEffect(() => {
    isEditGlobal = isEdit;
    setRowData([...rowData])
  }, [isEdit]);

  useEffect(() => {
    if (selectedIndex < 0 || isSponsorRoleSelect) {
      return;
    }
    const params = {
      accountNumber: userAcctList[selectedIndex].accountNumber,
      speedboat: Helper.speedboatReverseMappings[userAcctList[selectedIndex].speedboat],
      salesOrg: userAcctList[selectedIndex].salesOrg,
      userId: userAcctList[selectedIndex].userId,
      roles: selectedRoles.map(v => v.roleName),
    }

    async function fetchHere() {
      const res = await update_user_roles(params);
      if (res.isSuccessFull) {
        System.clearAllAlert();
        System.alert(res.data, 'success', 'userAcct')
        setRefreshGrid(true);
      } else {
        System.clearAllAlert();
        System.alert(res.message || res.errorMessage || "Error updating user roles", 'danger', 'userAcct')
      }
    }

    fetchHere();
    setIndex(-1)
  }, [selectedRoles]);
  useEffect(() => {
    roleData = roleList;
  }, [roleList])


  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall();
      __remove('USER_ACCOUNT_API_CALL')
    }

    __set('USER_ACCOUNT_API_CALL')
    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectionCount(0);
      await fetchAPICall();
      setRefreshGrid(false);
      __remove('USER_ACCOUNT_API_CALL')
    }

    if (refreshGrid) {
      __set('USER_ACCOUNT_API_CALL')
      fetchHere();
    }
  }, [refreshGrid]);

  const loadAccountNumber = (e) => {
    const data = e?.data ? e?.data : e.node.allLeafChildren[0]?.data;
    return <>
      <a
        href={Admin.getAdminAccountDetailURL() + '?accountNumber=' + data?.AccountNumber + '&salesOrg=' + data?.SalesOrg + '&speedboat=' + (data?.Speedboat === "Silica" ? 'S' : (data?.Speedboat === "Abacus" ? 'T' : 'B'))}
        className='' target="_blank"> {e?.value}</a>
    </>
  }

  useEffect(() => {
    let _userList = [];
    if (userAcctList.length > 0) {
      userAcctList.map((ele, idx) => {
        if (ele.accountNumber) {
          let _data = {
            EmailId: userDetail.emailAddress,
            UserName: userDetail.firstName + " " + userDetail.lastName,
            MobileNumber: userDetail.phoneNumber,
            TelephoneNumber: userDetail.telephoneNumber,
            UserCreateDate: userDetail.createDate ? Helper.getDatepickerFormatAdminConsole(userDetail.createDate) : "",
            UserUpdateDate: userDetail.updatedDate ? Helper.getDatepickerFormatAdminConsole(userDetail.updatedDate) : "",
            UserUsersStatus: userDetail.active ? 'Active' : 'Inactive',
            Source: userDetail.source,
            AccountNumber: ele.accountNumber,
            AccountName: ele.accountName,
            Role: ele.roles ? ele.roles.split(',').map(v => v.trim()) : [],
            Speedboat: ele.speedboat,
            SalesOrg: ele.salesOrg,
            Currency: ele.currency,
            OrderBlock: ele.orderBlock === true ? 'Yes' : ele.orderBlock === false ? 'No' : '',
            BillToCountry: ele.billToCountryCode,
            Description: ele.description,
            CreditRisk: ele.creditRisk === true ? 'Yes' : ele.creditRisk === false ? 'No' : '',
            PaymentTermID: ele.paymentTermId,
            Active: ele.active ? 'Active' : 'Inactive',
            CreatedOn: ele.createdDate ? Helper.getDatepickerFormatAdminConsole(ele.createdDate) : "",
            UpdatedOn: ele.updatedDate ? Helper.getDatepickerFormatAdminConsole(ele.updatedDate) : "",
            SDINumber: ele.sdiNumber,
            PECEmail: ele.pecEmail
          }
          _userList.push(_data);
        }
      })
      setRowData(_userList)
    } else {
      setRowData([])
    }

  }, [userAcctList, userDetail]);

  const [columnDefs] = useState([
    {field: 'EmailId', hide: true, headerName: 'EMAILID',},
    {field: 'UserName', hide: true, headerName: 'USERNAME',},
    {field: 'MobileNumber', hide: true, headerName: 'MOBILE NUMBER',},
    {field: 'TelephoneNumber', hide: true, headerName: 'TELEPHONE NUMBER',},
    {field: 'UserCreateDate', hide: true, headerName: 'USER CREATED ON',},
    {field: 'UserUpdateDate', hide: true, headerName: 'USER UPDATED ON',},
    {field: 'Source', hide: true, headerName: 'SOURCE',},
    {
      field: '', pinned: 'left', lockPosition: "left",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      enableFilter: false
    },
    {
      field: 'AccountNumber', pinned: 'left', minWidth: 150, lockPosition: "left",
      width: 50,
      enableFilter: false,
      suppressMovable: true,
      headerName: 'ACCOUNT NUMBER',
      headerTooltip: 'ACCOUNT NUMBER',
      sortable: true, comparator: Helper.textSortingAgGrid,
      cellRenderer: loadAccountNumber
    },
    {
      field: 'AccountName', pinned: 'left', minWidth: 200, suppressMovable: true, lockPosition: "left",
      headerName: 'ACCOUNT NAME',
      headerTooltip: 'ACCOUNT NAME',
      sortable: true, comparator: Helper.textSortingAgGrid
    },

    {
      field: 'Role',
      pinned: 'left',
      headerName: 'ROLE',
      lockPosition: "left",
      headerTooltip: 'ROLE',
      sortable: true,
      comparator: roleSortingAgGrid,
      cellRenderer: addRole
    },
    {
      field: 'Speedboat',
      minWidth: 130,
      headerName: 'SPEEDBOAT',
      headerTooltip: 'SPEEDBOAT',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'SalesOrg',
      minWidth: 130,
      headerName: 'SALES ORG',
      headerTooltip: 'SALES ORG',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'Currency',
      minWidth: 130,
      headerName: 'CURRENCY',
      headerTooltip: 'CURRENCY',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'OrderBlock',
      minWidth: 130,
      headerName: 'ORDER BLOCK',
      headerTooltip: 'ORDER BLOCK',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'BillToCountry',
      minWidth: 130,
      headerName: 'BILL TO COUNTRY',
      headerTooltip: 'BILL TO COUNTRY',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'Description',
      minWidth: 130,
      headerName: 'DESCRIPTION',
      headerTooltip: 'DESCRIPTION',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'CreditRisk',
      minWidth: 130,
      headerName: 'CREDIT RISK',
      headerTooltip: 'CREDIT RISK',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'PaymentTermID',
      minWidth: 130,
      headerName: 'PAYMENT TERM ID',
      headerTooltip: 'PAYMENT TERM ID',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'Active',
      minWidth: 130,
      headerName: 'STATUS',
      headerTooltip: 'STATUS',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'CreatedOn',
      minWidth: 180, headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    {
      field: 'UpdatedOn',
      minWidth: 180,
      headerName: 'UPDATED ON',
      headerTooltip: 'UPDATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    {
      field: 'SDINumber',
      minWidth: 130,
      headerName: 'SDI NUMBER',
      headerTooltip: 'SDI NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'PECEmail',
      minWidth: 150,
      headerName: 'PEC EMAIL',
      headerTooltip: 'PEC EMAIL',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },

  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      width: 150,
      resizable: true
    };
  }, []);

  const onSelectionChanged = () => {
    setSelectionCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const fetchAPICall = async () => {
    await get_user_acct_list(userId)
  };

  const exportGrid = async () => {
    if (isEdit)
      return false;

    const allColumnState = gridColumnApi.getColumnState();
    let customColumns = allColumnState.map((column) => column.colId);

    const params = {fileName: `user_detail.xlsx`, sheetName: "user", columnKeys: customColumns.slice(1)};

    await gridRef.current.api.exportDataAsExcel(params);
    /**
     * Ticket #  : 15807
     * Change #  : Clear Old message and alert error
     * Change by : PN
     * Date      : 13 Dec,2023
     */
    System.clearAllAlert();
    System.alert(Constants.downloadMsg, 'success', 'userAcct')
  }

  const onUnsponsorAcct = () => {
    if (gridRef.current.api.getSelectedRows().length > 0) {
      const list = gridRef.current.api.getSelectedRows();

      store.dispatch(system_notification({
        name: 'UnsponsorUserAcct',
        data: {
          userId, list,
          base: 'userDetails'
        },
      }));
    }
  }


  const isRowSelectable = (node) => {
    const rowData = node.data;
    return !isEditGlobal && !!(rowData && userDetail.source !== 'SAP');
  };

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    params.api.addEventListener('columnResized', onColumnResided);
    setGridColumnApi(params.columnApi);
  };

  return (
    <>
      {__check(['USER_DETAIL_API_CALL', 'USER_ACCOUNT_API_CALL']).render}
      {!__check(['USER_DETAIL_API_CALL', 'USER_ACCOUNT_API_CALL']).status &&
        <>
          {rowData.length > 0 &&
            <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
              <div className="d-flex justify-content-start">
                Filtered Line Count: <b>{agGridFiltered}</b>
              </div>
              <div className="d-flex justify-content-end">
                Total Records: <b>{totalUserRecords}</b>
              </div>
            </div>}

          <div className='bg-black p-2 px-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <button disabled={isEdit} className={`bs5 btn btn-secondary ${selectionCount > 0 ? '' : ' disabled'}`}
                        onClick={() => onUnsponsorAcct()}><i className="fas5 fa-user-minus text-darkgreen me-2"
                                                             aria-hidden="true"></i>UNSPONSOR FROM AN ACCOUNT
                </button>
              </div>
              <div>
                {/* <button className="bs5 btn btn-secondary me-3" onClick={() => onSave()}><i className="fas5 fa-user-plus text-darkgreen me-2" aria-hidden="true"></i>Save</button> */}
                <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'
                   onClick={exportGrid}>
                  <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                </a>
              </div>
            </div>
          </div>
          {rowData.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                onSelectionChanged={onSelectionChanged}
                isRowSelectable={isRowSelectable}
                onGridReady={onGridReady}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div>
            :
            <div>
              <NoResultContent message={userAcctListMessage || 'No sponsored account found'} type={userAcctListMessage ? 'danger' : 'info'} isDisplay={false}/>
            </div>
          }
        </>
      }
      <RoleSelection/>
    </>);
}
